import React from "react";
import { StoreModuleStatus } from "@constants";

export type Store = {
  moduleStatus: StoreModuleStatus;
};

export const StoreContext = React.createContext<Store>({
  moduleStatus: {
    badModules: [],
    modulesForStep: {},
    incompleteModules: {},
    partsByType: {},
    partsByLocation: {},
  },
});
